module.exports = __webpack_public_path__ + "static/resume-a4b1153c0798b8cd768c5fff28250d65.png";